"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _utils = require("../utils");
var _PressableItem = _interopRequireDefault(require("./PressableItem"));
var _ThemeProvider = require("../ThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _utils.selectSystemProps)([_utils.htmlAttrs]);
const styles = _StyleSheet.default.create({
  itemContainer: {
    display: 'flex',
    margin: 0
  },
  childContainer: {
    paddingLeft: 16
  },
  nestedChildContainer: {
    paddingLeft: 24
  }
});
const ListboxItem = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    href,
    label,
    isChild = false,
    nestedChild,
    onBlur,
    nextItemRef,
    prevItemRef,
    tokens,
    variant = {},
    LinkRouter,
    linkRouterProps,
    id,
    onPress = () => {},
    ...rest
  } = _ref;
  const selectedProps = selectProps({
    href,
    ...rest
  });
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('Listbox', tokens, variant, {
    isChild
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
    style: [styles.itemContainer, isChild && styles.childContainer, nestedChild && styles.nestedChildContainer],
    role: "option",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PressableItem.default, {
      href: href,
      isChild: isChild,
      onPress: onPress,
      onBlur: onBlur,
      nextItemRef: nextItemRef,
      prevItemRef: prevItemRef,
      ref: ref,
      tokens: getTokens,
      selectedProps: selectedProps,
      id: id,
      children: label
    })
  });
});
ListboxItem.displayName = 'ListboxItem';
ListboxItem.propTypes = {
  ...selectedSystemPropTypes,
  ..._utils.withLinkRouter.propTypes,
  href: _propTypes.default.string,
  isChild: _propTypes.default.bool,
  label: _propTypes.default.node.isRequired,
  nextItemRef: _propTypes.default.object,
  prevItemRef: _propTypes.default.object,
  onPress: _propTypes.default.func,
  nestedChild: _propTypes.default.bool
};
var _default = exports.default = (0, _utils.withLinkRouter)(ListboxItem);